import { Injectable } from "@angular/core";
import { CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { Observable } from "rxjs";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi/core/response.interface";
import { AddressBookContactParameter } from "../classes/address-book-contact.parameter";
import { AddressBookContactResponse } from "../interfaces/address-book-contact-response";

@Injectable()
export class AddressBookContactController {

  private controller: string = "/AddressBookContact/";

  constructor(private _webapi: CtWebapiService) {
  }

  addressBookContactList(parameter: AddressBookContactParameter | null = null): Observable<CtWebapiGenericResponse<AddressBookContactResponse>> {

    const request: DataRequest = new DataRequest(`${this.controller}AddressBookContactList`);

    if (parameter) {

      request
        .setQueryParams(parameter);

    }

    return this._webapi
      .get(request);

  }

  save(parameter: AddressBookContactParameter) {

    const request: DataRequest = new DataRequest(`${this.controller}Save`)
      .setBody(parameter);

    return this._webapi
      .post(request);

  }

  delete(parameter: AddressBookContactParameter) {

    const request: DataRequest = new DataRequest(`${this.controller}Delete`)
      .setQueryParams(parameter);

    return this._webapi
      .delete(request);

  }

}



